<template>
  <p>
    <span
      :class="[
        order.attributes.order_type === 'sale'
          ? 'font-bold text-gray-900'
          : '',
      ]"
    >{{ order.attributes.origin_code }}</span
    > /
    <span
      :class="[
        order.attributes.order_type === 'purchase'
          ? 'font-bold text-gray-900'
          : '',
      ]"
    >{{ order.attributes.destination_code }}</span>
  </p>
</template>

<script>
export default {
  props: {
    order: Object,
  }
};
</script>
